import React from 'react';
import './TopSectionBar.css';

const TopSectionBar = ({ sectionTitle, timeLeft }) => {



  const formatTime = (seconds) => {

    if (seconds === null || seconds === undefined) return '0:00';

    const mins = Math.floor(seconds / 60);

    const secs = seconds % 60;

    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;

  };



  return (

    <header className="top-section-bar">

      <h1 className="top-section-bar-heading">{sectionTitle}</h1>

      <div className="top-section-bar-timer">

        <span className="material-icons top-section-bar-timer-icon">timer</span>

        <span className="top-section-bar-timer-text">{formatTime(timeLeft)}</span>

      </div>

      <button className="top-section-bar-dark-mode-toggle" onClick={() => document.documentElement.classList.toggle('dark')}>

        <span className="material-icons dark:hidden">dark_mode</span>

        <span className="material-icons hidden dark:block">light_mode</span>

      </button>

    </header>

  );

};

export default TopSectionBar;
